import gql from 'graphql-tag';

export default gql`
  mutation CreateApplication($fields: JSON, $type: ApplicationType!, $stakeholderId: String!, $propertyId: String!) {
    createApplication(
      data: {
        fields: $fields
        type: $type
        stakeholderId: $stakeholderId
        propertyId: $propertyId
      }
    ) {
      id
      createdAt
      updatedAt
      fields
      stakeholder {
        id
      }
      property {
        id
      }
      status
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateApplication.ts